import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "8",
  height: "8",
  viewBox: "0 0 8 8",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M3.96532 5.10536L1.03482 7.83493C0.796625 8.05679 0.426843 8.05478 0.19108 7.83032C-0.0446916 7.60587 -0.064879 7.23663 0.145013 6.98782L2.71118 3.94575L0.152223 1.02057C-0.0620942 0.775581 -0.0485597 0.406059 0.183107 0.177406C0.414766 -0.0512471 0.784433 -0.0599522 1.0266 0.157562L3.96532 2.797L6.90405 0.157562C7.14621 -0.0599522 7.51588 -0.0512471 7.74754 0.177406C7.9792 0.406059 7.99274 0.775581 7.77842 1.02057L5.21946 3.94575L7.78563 6.98782C7.99552 7.23663 7.97534 7.60587 7.73956 7.83032C7.5038 8.05478 7.13402 8.05679 6.89582 7.83493L3.96532 5.10536Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }